module.exports = __webpack_public_path__ + "img/logo-console.14949f89.png";